import { IHit, ISort } from '@/store/state'
import axios from 'axios'

const headers = {
	'X-Requested-With': 'XMLHttpRequest',
	Accept: 'application/json',
	'Content-type': 'text/json'
}

export interface ISearchParams {
	query: string
	categories: any[]
	date: {
		start?: string
		end?: string
	}
	page: number
	sort: ISort
}

interface ISearchReturnObject {
	hits: IHit[]
	total: number
}
interface ISearchSuggestionsReturnObject {
	
}

// Used in searchAction (in actions.ts)
export const search = (
	searchURL: string,
	searchParams: ISearchParams
): Promise<ISearchReturnObject> =>
	axios.post(searchURL, searchParams, {
		headers
	})
	.then((response: any) => {
		return response.data
	})
	.catch((searchError: any) => {
		console.error({
			searchError
		})
		return {} as ISearchReturnObject
	})

export const serchSuggestions = (searchURL: string, query: string):
	Promise<any[]> =>
	axios.post(searchURL, {query: query}, {
		headers
	})
	.then((response: any) => {
		return response.data
	})
	.catch((searchError: any) => {
		console.error({
			searchError
		})
		return {} as any[]
	})
